import React, { useState, useEffect } from 'react';
import { IEditorProps } from '../Editor';
import { TimePickerDropdown } from 'components/inputs/date-time/TimePickerDropdown';
import moment from 'moment';
import { getEditorConfigValue } from 'components/property-editors/utils/EditorConfigurationUtils';
import { TimeFormats } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/Portal/TimeFormats';
import { EditorLabel } from '../EditorLabel';
import { getEditorValidationSummary } from 'utils/ValidationUtils';
import { getChildValue } from 'components/property-editors/utils/ProviderNodeUtils';
import { getMoment } from 'utils/DateTimeUtils';
// import './TimePickerEditor.less'

interface ITimePickerEditorProps extends IEditorProps {}

/**
 * Time Selection Dropdown
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function TimePickerEditor({ child, path, hideInputLabel, onChange }: ITimePickerEditorProps) {
  const [currentDate, setCurrentDate] = useState<moment.Moment>();
  const validation = getEditorValidationSummary(child);
  const isDate: boolean = getEditorConfigValue(child, 'IsDate'); // wat?
  const isNullable: boolean = getEditorConfigValue(child, 'IsNullable');
  const childValue = getChildValue(child);
  useEffect(() => {
    const date = getMoment().utc(childValue);
    if (date) {
      setCurrentDate(date);
    }
  }, [isDate, childValue]);

  const handleChange = (date?: moment.Moment) => {
    if (!date && isNullable) {
      // submitDateTimeValue({ editingContextId, path, dateTime: '' });
      onChange('', path);
      return;
    } else if (!date) {
      // TODO put back what was there before - ignore the change (what?)
      return;
    }

    // create a utc date object and set the hours and minutes, to make sure it works when client and server are in different time zone.
    const utcDate = getMoment().utc();
    utcDate.hours(date.hours());
    utcDate.minutes(date.minutes());

    setCurrentDate(utcDate);
    const jsDate = utcDate.toDate();
    // Legacy seems to save a date object calling setValue directly, relying on JSON serialization to capture it as a string.
    // submitDateTimeValue({ editingContextId, path, dateTime });
    onChange(jsDate, path);
  };

  return (
    <EditorLabel editor={child} path={path} doNotWrap hideInputLabel={hideInputLabel}>
      <TimePickerDropdown
        currentDate={currentDate}
        onChange={handleChange}
        timeFormat={TimeFormats.Use12HourFormat}
        showSeconds={false}
        validation={validation}
      />
    </EditorLabel>
  );
}
